import { useEffect} from "react";
import BonusCard from "./BonusCard";
import LoaderComp from "../../components/LoaderComp";
import { useSelector } from "react-redux";
import { getBonus } from "../../redux/slice/bonusSlice";
import WhatsappBtn from "./WhatsappBtn";

const PreSetBonus = (props) => {
  const bonusCard = useSelector(getBonus);
  return (
    <div className="p-[30px] max-sm:px-[15px]">
      <div className="flex flex-wrap gap-[15px_20px]">
        {
          bonusCard.loading ? <LoaderComp /> :
          <>
            {
              bonusCard.bonus.length > 0 ?
              bonusCard.bonus.map((item,idx)=>{
                return(
                  <BonusCard key={idx} bonus={item} editOpt closeBonusPopUp={(state) => props.editBonusCard(state)} pagePermissions={props.pagePermissions} />
                )
              }) : 
              <h2 className="font-[700] text-2xl text-center w-full">No Products</h2>
            }
          </>
        }
      </div>
      <WhatsappBtn />
    </div>
  )
};

export default PreSetBonus;
